import React, { createContext, useContext, useMemo } from 'react'

import { getActiveChainId } from './active'
import { resolveWidgetChainScope } from './scope'
import type { WidgetChainScope } from './types'

const ChainScopeContext = createContext<WidgetChainScope | undefined>(undefined)

export type ChainScopeProviderProps = {
  children: React.ReactNode
  /** Scope por defecto para toda la app (Fase 5: cadena activa). */
  defaultScope?: WidgetChainScope
}

export function ChainScopeProvider({ children, defaultScope }: ChainScopeProviderProps) {
  const value = useMemo<WidgetChainScope>(
    () =>
      defaultScope ?? {
        chainId: getActiveChainId(),
        mode: 'write',
      },
    [defaultScope],
  )

  return <ChainScopeContext.Provider value={value}>{children}</ChainScopeContext.Provider>
}

/**
 * Cadena efectiva del widget: prop `chainScope` > contexto > cadena activa del build.
 */
export function useWidgetChainScope(override?: WidgetChainScope): WidgetChainScope {
  const fromContext = useContext(ChainScopeContext)
  return resolveWidgetChainScope(override ?? fromContext)
}
